import React from "react";

export class NewBreadcrumb extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{display: "inline-block", minHeight: 30, width: "100%"}}>
        <div style={{width: "70%"}}>
          {this.props.crumbs && this.props.crumbs.map((crumb, index) => {
            return (
              <span key={index}>
                          <span style={{cursor: "pointer", color: "#00F"}}
                                onClick={() => this.props.onClick && this.props.onClick(crumb.id, index)}>
                            {`${crumb.display}`}
                          </span>
                          <span>{`${index > 0 ? " / " : " "}`}</span>
                        </span>
            )
          })}
        </div>
        <div style={{width: "30%"}}>
          {/*<input type={"text"} placeholder={"Search files or folders"} value={""}/>*/}
        </div>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Breadcrumb/NewBreadcrumb.js